import { showsTranslationPreview } from "../i18n/languages";
import { useSession } from "../state/SessionProvider";

/**
 * Calm disclosure for soft-launch draft translations — not professionally reviewed.
 */
export function TranslationPreviewNotice() {
  const { languageCode, translate, setLanguageCode } = useSession();

  if (!showsTranslationPreview(languageCode)) {
    return null;
  }

  return (
    <aside
      className="translation-preview-notice"
      role="note"
      aria-labelledby="translation-preview-heading"
    >
      {/* Use a strong paragraph, not h2, so page h1 remains the first heading. */}
      <p id="translation-preview-heading" className="translation-preview-title">
        {translate("locale.translation_preview.title")}
      </p>
      <p>{translate("locale.translation_preview.body")}</p>
      <button
        type="button"
        className="text-action"
        onClick={() => setLanguageCode("en")}
      >
        {translate("locale.translation_preview.use_english")}
      </button>
    </aside>
  );
}
